/**
 * Quiz Results Page: Multi-Channel Integration
 * Email automation, SMS, retargeting pixels, push notifications
 */

(function() {
  'use strict';

  function trackAbandonment() {
    const abandonmentData = {
      timestamp: Date.now(),
      page: 'quiz-results',
      url: window.location.href,
      quizResults: sessionStorage.getItem('veluna_quiz_results'),
      category: new URLSearchParams(window.location.search).get('category'),
      bundle: new URLSearchParams(window.location.search).get('bundle')
    };

    localStorage.setItem('veluna_abandonment_data', JSON.stringify(abandonmentData));

    if (window.VelunaQuizResultsCart && window.VelunaQuizResultsCart.trackEvent) {
      window.VelunaQuizResultsCart.trackEvent('quiz_results_viewed', {
        category: abandonmentData.category,
        bundle: abandonmentData.bundle,
        timestamp: abandonmentData.timestamp
      });
    }
  }

  function trackConversion() {
    const abandonmentData = JSON.parse(localStorage.getItem('veluna_abandonment_data') || '{}');

    if (abandonmentData.timestamp) {
      abandonmentData.converted = true;
      abandonmentData.conversionTimestamp = Date.now();
      localStorage.setItem('veluna_abandonment_data', JSON.stringify(abandonmentData));
      localStorage.removeItem('veluna_abandonment_pending');
    }
  }

  function initRetargetingPixels() {
    const urlParams = new URLSearchParams(window.location.search);
    const category = urlParams.get('category');
    const bundle = urlParams.get('bundle');

    // Keep quiz-results pageview in GA and other channels without creating
    // a second Meta event outside the shared storefront tracker.
    if (typeof gtag !== 'undefined') {
      gtag('event', 'view_item', {
        items: [{
          item_name: `${category} ${bundle}`,
          item_category: category,
          price: 79,
          currency: 'USD'
        }]
      });
    }

    if (typeof pintrk !== 'undefined') {
      pintrk('track', 'pagevisit', {
        product_name: `${category} ${bundle}`,
        product_category: category
      });
    }
  }

  function requestPushPermission() {
    if ('Notification' in window && Notification.permission === 'default') {
      let scrolled = false;
      window.addEventListener('scroll', function() {
        if (!scrolled && (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) > 0.5) {
          scrolled = true;
          Notification.requestPermission().then(permission => {
            if (permission === 'granted') {
              localStorage.setItem('veluna_push_permission', 'granted');
            }
          });
        }
      }, { once: true });
    }
  }

  function trackForSMS() {
    const intentSignals = {
      timeOnPage: 0,
      scrollDepth: 0,
      interactions: 0
    };

    const startTime = Date.now();
    window.addEventListener('beforeunload', function() {
      intentSignals.timeOnPage = Math.floor((Date.now() - startTime) / 1000);
      localStorage.setItem('veluna_sms_intent', JSON.stringify(intentSignals));
    });

    let maxScroll = 0;
    window.addEventListener('scroll', function() {
      const scrollPercent = (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100;
      maxScroll = Math.max(maxScroll, scrollPercent);
      intentSignals.scrollDepth = Math.round(maxScroll);
    });

    document.addEventListener('click', function() {
      intentSignals.interactions++;
    });
  }

  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
      return;
    }

    trackAbandonment();
    initRetargetingPixels();
    requestPushPermission();
    trackForSMS();

    document.querySelectorAll('[data-results-add-to-cart]').forEach(btn => {
      btn.addEventListener('click', function() {
        trackConversion();
      });
    });

    console.log('Quiz Results Multi-Channel: Tracking initialized');
  }

  init();

  if (typeof window !== 'undefined') {
    window.VelunaQuizResultsMultiChannel = {
      trackAbandonment,
      trackConversion,
      initRetargetingPixels
    };
  }
})();

